module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-top-metals.83ad8b43.png";